let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hAnJr")).then(() => parcelRequire('cfjbS'));